import * as actions from './redux/actions';

import React, { Component, PureComponent } from 'react';

import CommonService from '../../services/commonService';
import KuposInput from '../common/KuposInput';
import KuposSelectBox from '../common/KuposSelectBox';
import PaymentRightSideBar from './PaymentRightSideBar';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class BookingInput extends PureComponent {
	// const {selectedSeatsToBook,countries,idCardTypes,name, countryName, cardNumber, nameError,cardNumberError onNameChange, onCountryChange, onIdCardChange, onIdCardNumberChange,onInputBlur} = this.props;
	constructor(props) {
		super(props);
		this.state = {};
	}

	nameChanged = (text, seat) => {
		this.props.onNameChange(text, seat);
	};

	surnameChanged = (text, seat) => {
		this.props.onSurnameChange(text, seat);
	};
	inputBlur = (text, seat, inp) => {
		this.props.onInputBlur(text, seat, inp);
	};
	countryChanged = (val, seat) => {
		this.props.onCountryChange(val, seat);
	};
	idCardChanged = (label, seat) => {
		this.props.onIdCardChange(label, seat);
	};
	idCardNumberChanged = (text, seat) => {
		this.props.onIdCardNumberChange(text, seat);
	};

	seatInputs = (seat, i) => {
		let passengerDetails = CommonService.copyObject(this.props.passengerDetails);
		let passenger =
			passengerDetails && passengerDetails.length
				? passengerDetails.find((it) => seat.number == it.seatNumber)
				: null;
		return (
			<tr key={i} className="passenger-input">
				<td className="nationality-input">
					<KuposSelectBox
						options={this.props.countries}
						selectedOption={passenger ? passenger.nationality : {}}
						onChange={(val) => this.countryChanged(val, seat)}
						height={50}
					/>
				</td>
				<td className="rut-input">
					<KuposInput
						className="kupos-border"
						type="text"
						placeholder="N°de documento"
						value={passenger ? passenger.idCardNumber : ''}
						onChange={(text) => this.idCardNumberChanged(text, seat)}
						onBlur={(text) => this.inputBlur(text, seat, 'card_number')}
						error={
							this.props.cardNumberError && this.props.cardNumberError[seat.number] ? true : false
						}
						errorMessage={
							this.props.cardNumberError && this.props.cardNumberError[seat.number]
								? this.props.cardNumberError[seat.number].message
								: ''
						}
					/>
				</td>
				<td className="name-input">
					<KuposInput
						className="kupos-border"
						type="text"
						placeholder="Nombre y apellido"
						value={passenger ? passenger.name : ''}
						onChange={(text) => this.nameChanged(text, seat)}
						onBlur={(text) => this.inputBlur(text, seat, 'name')}
						error={this.props.nameError && this.props.nameError[seat.number] ? true : false}
						errorMessage={
							this.props.nameError && this.props.nameError[seat.number]
								? this.props.nameError[seat.number].message
								: ''
						}
					/>
				</td>
				<td className="name-input">
					<KuposInput
						className="kupos-border"
						type="text"
						placeholder="Nombre y apellido"
						value={passenger ? passenger.surname : ''}
						onChange={(text) => this.surnameChanged(text, seat)}
						onBlur={(text) => this.inputBlur(text, seat, 'surname')}
						error={this.props.surnameError && this.props.surnameError[seat.number] ? true : false}
						errorMessage={
							this.props.surnameError && this.props.surnameError[seat.number]
								? this.props.surnameError[seat.number].message
								: ''
						}
					/>
				</td>
			</tr>
		);
	};

	render() {
		return (
			<table>
				<tbody>
					<tr className="passenger-input-heading bold">
						<th className="nationality-input">Nationality</th>
						<th className="rut-input">RUT / Passport / DNI</th>
						<th className="name-input">Name</th>
						<th className="surname-input">Surname</th>
					</tr>
					{this.props.selectedSeatsToBook.map((seat, i) => this.seatInputs(seat, i))}
				</tbody>
			</table>
		);
	}
}

export default class PaymentDetailsPage extends Component {
	static propTypes = {
		pbServiceList: PropTypes.object,
		home: PropTypes.object,
		actions: PropTypes.object,
	};
	countrieCodes = [];
	paymentGatewayList;
	countries = [];
	idCardTypes = [];
	idCardTypesReturn = [];

	constructor(props) {
		super(props);
		for (let c of this.props.home.metaData.country_codes) {
			this.countrieCodes.push({
				value: c,
				label: '+' + c,
			});
		}
		for (let c in this.props.home.metaData.nationality_list) {
			this.countries.push({
				value: this.props.home.metaData.nationality_list[c],
				label: c,
			});
		}
		this.paymentGatewayList = CommonService.copyObject(
			this.props.home.metaData.payment_gate_way_list_v1,
		);
		this.state = {
			mobileError: null,
			emailError: null,
			confirmEmailError: null,
			selectedPaymentGateway: null,
			showBookingConfirmModal: false,
			wallet: false,
			walletMoney: 0,
			confirmTabSelected: 1,

			nameError: {},
			surnameError: {},
			cardNumberError: {},
			nameReturnError: {},
			surnameReturnError: {},
			cardNumberReturnError: {},
			idCardTypes: [],
			idCardTypesReturn: [],
		};
		let contactDetails = {
			countryCode: this.countrieCodes[0].name,
			mobile: this.props.home.loginData ? this.props.home.loginData.phone : null,
			email: this.props.home.loginData ? this.props.home.loginData.email : null,
			confirmEmail: this.props.home.loginData ? this.props.home.loginData.email : null,
		};
		this.props.actions.setContactDetails(contactDetails);
		// this.props.actions.setBookingJSONDetails(null);

		let passengerDetailsOnward = [];
		let i = 0;
		if (this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
			for (let s of this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook) {
				passengerDetailsOnward.push({
					seatNumber: s.number,
					name: i == 0 && this.props.home.loginData ? this.props.home.loginData.name : null,
					nationality: this.countries[0],
					idCardType:
						i == 0 && this.props.home.loginData && Object.keys(this.props.home.loginData).length
							? this.props.home.loginData.identity_type
							: 7,
					idCardNumber:
						i == 0 && this.props.home.loginData && Object.keys(this.props.home.loginData).length
							? this.props.home.loginData.identity_val
							: null,
					fare: s.fare,
				});
				let cardTypes = [];
				for (let c in this.props.home.metaData.id_card_types) {
					cardTypes.push({
						value: this.props.home.metaData.id_card_types[c],
						id: this.props.home.metaData.id_card_types[c],
						label: c,
						name: c,
						selected:
							this.props.home.loginData && i == 0
								? this.props.home.metaData.id_card_types[c] ==
								this.props.home.loginData.identity_type
								: this.props.home.metaData.id_card_types[c] == 7,
					});
				}
				this.idCardTypes.push(cardTypes);
				i++;
			}
		}
		i = 0;
		this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
		if (this.props.home.returnPBDate) {
			let passengerDetailsReturn = [];
			if (this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
				for (let s of this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook) {
					passengerDetailsReturn.push({
						seatNumber: s.number,
						name: null,
						nationality: this.countries[0],
						idCardType: 7,
						idCardNumber: null,
						fare: s.fare,
					});
					let cardTypes = [];
					for (let c in this.props.home.metaData.id_card_types) {
						cardTypes.push({
							value: this.props.home.metaData.id_card_types[c],
							id: this.props.home.metaData.id_card_types[c],
							label: c,
							name: c,
							selected: this.props.home.metaData.id_card_types[c] == 7,
						});
					}
					this.idCardTypesReturn.push(cardTypes);
					i++;
				}
			}
			this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
		}
		this.state.idCardTypes = this.idCardTypes;
		this.state.idCardTypesReturn = this.idCardTypesReturn;
	}

	onInputChange = (text, inp) => {
		if (text) {
			if (inp == 'mobile') {
				this.setState({
					mobileError: null,
				});
				let contactDetails = CommonService.copyObject(this.props.pbServiceList.contactDetails);
				if (contactDetails) {
					text = CommonService.phoneNumberFormat(text);
					contactDetails.mobile = text;
					this.props.actions.setContactDetails(contactDetails);
				}
			} else if (inp == 'email') {
				this.setState({
					emailError: null,
				});
				let contactDetails = CommonService.copyObject(this.props.pbServiceList.contactDetails);
				if (contactDetails) {
					contactDetails.email = text;
					this.props.actions.setContactDetails(contactDetails);
				}
			} else if (inp == 'confirmEmail') {
				this.setState({
					confirmEmailError: null,
				});
				let contactDetails = CommonService.copyObject(this.props.pbServiceList.contactDetails);
				if (contactDetails) {
					contactDetails.confirmEmail = text;
					this.props.actions.setContactDetails(contactDetails);
				}
			}
		}
	};

	onInputBlurContact = (text, inp) => {
		if (!text) {
			if (inp == 'mobile') {
				this.setState({
					mobileError: {
						message: 'Por favor ingrese N° Móvil.',
					},
				});
			} else if (inp == 'email') {
				this.setState({
					emailError: {
						message: 'Introduzca su correo electrónico',
					},
				});
			} else if (inp == 'confirmEmail') {
				this.setState({
					confirmEmailError: {
						message: 'Por favor, recuerda que ambos correos deben ser iguales',
					},
				});
			}
		} else {
			let contactDetails = CommonService.copyObject(this.props.pbServiceList.contactDetails);

			if (inp == 'mobile') {
				if (isNaN(text))
					this.setState({
						mobileError: {
							message: 'entrar válido N° Móvil.',
						},
					});
			} else if (inp == 'email') {
				if (!CommonService.isEMailValid(text)) {
					this.setState({
						emailError: {
							message: 'entrar válido E-Mail',
						},
					});
				}
			} else if (inp == 'confirmEmail') {
				if (contactDetails.confirmEmail != contactDetails.email) {
					this.setState({
						confirmEmailError: {
							message: 'Por favor, recuerda que ambos correos deben ser iguales',
						},
					});
				}
			}
		}
	};

	// --------- booking seats input on change/blur code start -------------------
	onNameChange = (text, seat) => {
		let nameError = CommonService.copyObject(this.state.nameError);
		if (nameError) {
			nameError[seat.number] = null;
		}
		this.setState({
			nameError: nameError,
		});
		let passengerDetailsOnward = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsOnward,
		);
		let passenger = passengerDetailsOnward.find((it) => seat.number == it.seatNumber);
		if (passenger) {
			passenger.name = text;
			this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
		}
	};
	onNameChangeReturn = (text, seat) => {
		let nameReturnError = CommonService.copyObject(this.state.nameReturnError);
		if (nameReturnError) {
			nameReturnError[seat.number] = null;
		}
		this.setState({
			nameReturnError: nameReturnError,
		});
		let passengerDetailsReturn = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsReturn,
		);
		let passenger = passengerDetailsReturn.find((it) => seat.number == it.seatNumber);
		if (passenger) {
			passenger.name = text;
			this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
		}
	};
	onSurnameChange = (text, seat) => {
		let surnameError = CommonService.copyObject(this.state.surnameError);
		if (surnameError) {
			surnameError[seat.number] = null;
		}
		this.setState({
			surnameError: surnameError,
		});
		let passengerDetailsOnward = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsOnward,
		);
		let passenger = passengerDetailsOnward.find((it) => seat.number == it.seatNumber);
		if (passenger) {
			passenger.surname = text;
			this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
		}
	};
	onSurnameChangeReturn = (text, seat) => {
		let surnameReturnError = CommonService.copyObject(this.state.surnameReturnError);
		if (surnameReturnError) {
			surnameReturnError[seat.number] = null;
		}
		this.setState({
			surnameReturnError: surnameReturnError,
		});
		let passengerDetailsReturn = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsReturn,
		);
		let passenger = passengerDetailsReturn.find((it) => seat.number == it.seatNumber);
		if (passenger) {
			passenger.surname = text;
			this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
		}
	};
	onCountryChange = (val, seat) => {
		console.log(val, seat);
		let passengerDetailsOnward = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsOnward,
		);
		let passenger = passengerDetailsOnward.find((it) => seat.number == it.seatNumber);
		if (passenger) {
			passenger.nationality = val;
			this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
		}
	};
	onCountryChangeReturn = (val, seat) => {
		console.log(val, seat);
		let passengerDetailsReturn = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsReturn,
		);
		let passenger = passengerDetailsReturn.find((it) => seat.number == it.seatNumber);
		if (passenger) {
			passenger.nationality = val;
			this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
		}
	};
	onIdCardChange = (val, seat) => {
		console.log(val, seat);
		let passengerDetailsOnward = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsOnward,
		);
		let passenger = passengerDetailsOnward.find((it) => seat.number == it.seatNumber);
		if (passenger) {
			passenger.idCardType = val.value;
			passenger.idCardNumber = '';
			let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
			if (cardNumberError) {
				cardNumberError[seat.number] = null;
			}
			this.setState({
				cardNumberError: cardNumberError,
			});
			this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
		}
	};
	onIdCardChangeReturn = (val, seat) => {
		console.log(val, seat);
		let passengerDetailsReturn = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsReturn,
		);
		let passenger = passengerDetailsReturn.find((it) => seat.number == it.seatNumber);
		if (passenger) {
			passenger.idCardType = val.value;
			passenger.idCardNumber = '';
			let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
			if (cardNumberReturnError) {
				cardNumberReturnError[seat.number] = null;
			}
			this.setState({
				cardNumberReturnError: cardNumberReturnError,
			});
			this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
		}
	};
	onIdCardNumberChange = (text, seat) => {
		let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
		if (cardNumberError) {
			cardNumberError[seat.number] = null;
		}
		this.setState({
			cardNumberError: cardNumberError,
		});
		let passengerDetailsOnward = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsOnward,
		);
		let passenger = passengerDetailsOnward.find((it) => seat.number == it.seatNumber);
		if (passenger) {
			passenger.idCardNumber = CommonService.isRut(passenger.idCardType, this.idCardTypes[0])
				? CommonService.formatRut(text)
				: text;
			this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);
		}
	};
	onIdCardNumberChangeReturn = (text, seat) => {
		let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
		if (cardNumberReturnError) {
			cardNumberReturnError[seat.number] = null;
		}
		this.setState({
			cardNumberReturnError: cardNumberReturnError,
		});
		let passengerDetailsReturn = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsReturn,
		);
		let passenger = passengerDetailsReturn.find((it) => seat.number == it.seatNumber);
		if (passenger) {
			passenger.idCardNumber = CommonService.isRut(passenger.idCardType, this.idCardTypes[0])
				? CommonService.formatRut(text)
				: text;
			this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
		}
	};

	onInputBlur = (text, seat, inp) => {
		console.log(text, seat, inp);
		let passengerDetailsOnward = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsOnward,
		);
		let passenger = passengerDetailsOnward.find((it) => seat.number == it.seatNumber);
		if (!text) {
			if (inp == 'name') {
				let nameError = CommonService.copyObject(this.state.nameError);
				if (nameError) {
					nameError[seat.number] = {
						message: 'VALIDATIONS.VALID_NAME',
					};
				}
				this.setState({
					nameError: nameError,
				});
			} else if (inp == 'surname') {
				let surnameError = CommonService.copyObject(this.state.surnameError);
				if (surnameError) {
					surnameError[seat.number] = {
						message: 'VALIDATIONS.VALID_SURNAME',
					};
				}
				this.setState({
					surnameError: surnameError,
				});
			} else if (inp == 'card_number') {
				let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
				if (cardNumberError) {
					cardNumberError[seat.number] = {
						// message:CommonService.isRut(passenger.idCardType,this.idCardTypes[0]) ? 'Por favor ingrese RUT válido.' : 'Por favor ingrese Pasaporte válido.'
						message: 'VALIDATIONS.VALID_PASSPORT',
					};
				}
				this.setState({
					cardNumberError: cardNumberError,
				});
			}
		}
		if (inp == 'card_number') {
			// if(CommonService.isRut(passenger.idCardType,this.idCardTypes[0])){
			//     if(!CommonService.isRutValid(passenger.idCardNumber)){
			//         let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
			//         if(cardNumberError){
			//             cardNumberError[seat.number] = {
			//                 message:'Por favor ingrese RUT válido.'
			//             };
			//         }
			//         this.setState({
			//             cardNumberError:cardNumberError
			//         })
			//     }
			//     passenger.idCardNumber = CommonService.isRut(passenger.idCardType,this.idCardTypes[0]) ? CommonService.formatRut(text) : text;
			//     this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward)
			// }
		}
	};

	onInputBlurReturn = (text, seat, inp) => {
		console.log(text, seat, inp);
		let passengerDetailsReturn = CommonService.copyObject(
			this.props.pbServiceList.passengerDetailsReturn,
		);
		let passenger = passengerDetailsReturn.find((it) => seat.number == it.seatNumber);
		if (!text) {
			if (inp == 'name') {
				let nameReturnError = CommonService.copyObject(this.state.nameReturnError);
				if (nameReturnError) {
					nameReturnError[seat.number] = {
						message: 'VALIDATIONS.VALID_NAME',
					};
				}
				this.setState({
					nameReturnError: nameReturnError,
				});
			} else if (inp == 'surname') {
				let surnameReturnError = CommonService.copyObject(this.state.surnameReturnError);
				if (surnameReturnError) {
					surnameReturnError[seat.number] = {
						message: 'VALIDATIONS.VALID_SURNAME',
					};
				}
				this.setState({
					surnameReturnError: surnameReturnError,
				});
			} else if (inp == 'card_number') {
				let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
				if (cardNumberReturnError) {
					cardNumberReturnError[seat.number] = {
						message: CommonService.isRut(passenger.idCardType, this.idCardTypes[0])
							? 'VALIDATIONS.VALID_RUT'
							: 'VALIDATIONS.VALID_PASSPORT',
					};
				}
				this.setState({
					cardNumberReturnError: cardNumberReturnError,
				});
			}
		}
		if (inp == 'card_number') {
			if (CommonService.isRut(passenger.idCardType, this.idCardTypes[0])) {
				if (!CommonService.isRutValid(passenger.idCardNumber)) {
					let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
					if (cardNumberReturnError) {
						cardNumberReturnError[seat.number] = {
							message: 'VALIDATIONS.VALID_RUT_VALID',
						};
					}
					this.setState({
						cardNumberReturnError: cardNumberReturnError,
					});
				}
				passenger.idCardNumber = CommonService.isRut(passenger.idCardType, this.idCardTypes[0])
					? CommonService.formatRut(text)
					: text;
				this.props.actions.setPassengerDetailsReturn(passengerDetailsReturn);
			}
		}
	};

	onSubmit = () => {
		let contactDetails = CommonService.copyObject(this.props.pbServiceList.contactDetails);
		let mobileError = null;
		let emailError = null;
		let confirmEmailError = null;

		let passengerDetailsOnward = CommonService.copyObject(this.props.data.passengerDetailsOnward);
		let passengerDetailsReturn = CommonService.copyObject(this.props.data.passengerDetailsReturn);
		let nameError = CommonService.copyObject(this.state.nameError);
		let cardNumberError = CommonService.copyObject(this.state.cardNumberError);
		let nameReturnError = CommonService.copyObject(this.state.nameReturnError);
		let cardNumberReturnError = CommonService.copyObject(this.state.cardNumberReturnError);
		let errorCount = 0;
		if (!contactDetails.mobile) {
			mobileError = {
				message: 'VALIDATIONS.VALID_NAME',
			};
			errorCount++;
		}
		if (!contactDetails.email) {
			emailError = {
				message: 'VALIDATIONS.VALID_SURNAME',
			};
			errorCount++;
		} else if (!CommonService.isEMailValid(contactDetails.email)) {
			emailError = {
				message: 'VALIDATIONS.VALID_NO_EMAIL',
			};
			errorCount++;
		}
		if (contactDetails.confirmEmail != contactDetails.email) {
			confirmEmailError = {
				message: 'VALIDATIONS.VALID_EMAIL_MATCH',
			};
			errorCount++;
		}
		if (this.state.promoCodeChecked) {
			if (!this.state.promoCode) {
				errorCount++;
				this.setState({
					promoCodeError: {
						message: 'VALIDATIONS.VALID_PROMOTION',
					},
				});
			}
		}
		for (let p of passengerDetailsOnward) {
			if (!p.name) {
				if (nameError) {
					nameError[p.seatNumber] = {
						message: 'VALIDATIONS.VALID_NAME',
					};
				}
				errorCount++;
			}
			if (!p.idCardNumber) {
				if (cardNumberError) {
					cardNumberError[p.seatNumber] = {
						message: CommonService.isRut(p.idCardType, this.idCardTypes[0])
							? 'VALIDATIONS.VALID_RUT'
							: 'VALIDATIONS.VALID_DOCUMENT_NUMBER',
					};
				}
				errorCount++;
			} else {
				if (
					CommonService.isRut(p.idCardType, this.idCardTypes[0]) &&
					!CommonService.isRutValid(p.idCardNumber)
				) {
					if (cardNumberError) {
						cardNumberError[p.seatNumber] = {
							message: 'VALIDATIONS.VALID_RUT_VALID',
						};
					}
					errorCount++;
				}
			}
		}
		if (this.props.data.selectedReturnDate) {
			for (let p of passengerDetailsReturn) {
				if (!p.name) {
					if (nameReturnError) {
						nameReturnError[p.seatNumber] = {
							message: 'VALIDATIONS.VALID_NAME',
						};
					}
					errorCount++;
				}
				if (!p.idCardNumber) {
					if (cardNumberReturnError) {
						cardNumberReturnError[p.seatNumber] = {
							message: CommonService.isRut(p.idCardType, this.idCardTypes[0])
								? 'VALIDATIONS.VALID_RUT'
								: 'VALIDATIONS.VALID_PASSPORT',
						};
					}
					errorCount++;
				} else {
					if (
						CommonService.isRut(p.idCardType, this.idCardTypes[0]) &&
						!CommonService.isRutValid(p.idCardNumber)
					) {
						if (cardNumberReturnError) {
							cardNumberReturnError[p.seatNumber] = {
								message: 'VALIDATIONS.VALID_RUT_VALID',
							};
						}
						errorCount++;
					}
				}
			}
		}
		this.setState({
			mobileError: mobileError,
			emailError: emailError,
			confirmEmailError: confirmEmailError,
			nameError: nameError,
			surnameError: nameError,
			cardNumberError: cardNumberError,
			nameReturnError: nameReturnError,
			cardNumberReturnError: cardNumberReturnError,
		});
		if (errorCount <= 0) {
		}
	};

	onPaymentTypeSelect = (paymentItem) => {
		this.setState({
			selectedPaymentGateway: paymentItem.code,
		});
	};

	walletMoneyAdded = (netFare) => {
		if (this.state.walletMoney) {
			let money = this.state.walletMoney;
			let virtualMoney = 0;
			if (this.state.virtual) {
				virtualMoney = this.virtualMoneyAmount();
			}
			if (money) {
				if (
					+money >
					+netFare - +(this.state.promoCouponAmount ? this.state.promoCouponAmount : 0)
				) {
					return (
						+netFare -
						+(this.state.promoCouponAmount ? this.state.promoCouponAmount : 0) -
						virtualMoney
					);
				}
				return +money;
			}
		}
		return 0;
	};

	virtualMoneyAmount = () => {
		if (
			this.props.home &&
			this.props.home.metaData &&
			this.props.home.metaData.allowed_virtual_limit &&
			this.state.virtualMoney
		) {
			let money = +(
				(this.props.home.metaData.allowed_virtual_limit / 100) *
				this.state.virtualMoney
			).toFixed(0);
			return money > this.basicFare() ? this.basicFare() : money;
		}
		return +((0 / 100) * this.state.virtualMoney).toFixed(0);
	};

	basicFare = () => {
		let fare =
			this.props.pbServiceList && this.props.pbServiceList.bookingDetailsOnward
				? this.props.pbServiceList.bookingDetailsOnward.netBookingAmount
				: 0;
		if (this.props.home.returnPBDate) {
			fare +=
				this.props.pbServiceList && this.props.pbServiceList.bookingDetailsReturn
					? this.props.pbServiceList.bookingDetailsReturn.netBookingAmount
					: 0;
		}
		return fare;
	};

	calculateNetFare = () => {
		let fare = this.basicFare();
		let virtualMoney = 0;
		if (this.state.virtual) {
			virtualMoney = this.virtualMoneyAmount();
		}
		if (this.state.wallet) {
			fare = fare - +this.walletMoneyAdded(fare) < 0 ? 0 : fare - +this.walletMoneyAdded(fare);
		}
		let netFare = fare - +(this.state.promoCouponAmount ? this.state.promoCouponAmount : 0);
		return netFare - virtualMoney > 0 ? netFare - virtualMoney : 0;
	};

	calculateNetFareUSD = () => {
		if (
			this.props.home &&
			this.props.home.metaData &&
			this.props.home.metaData.currency_conversions
		) {
			return (
				this.calculateNetFare() * this.props.home.metaData.currency_conversions.clp_to_usd
			).toFixed('2');
		}
	};

	renderContactInputTable = () => {
		return (
			<table className="passenger-input-personal-details">
				<tbody>
					<tr className="passenger-input-heading bold">
						<th className="emailinput">Email ID</th>
						<th className="email-input">Email Confirmation</th>
						<th className="phone-input">Phone Number</th>
					</tr>
					<tr className="passenger-input">
						<td className="email-input">
							<KuposInput
								className="kupos-border"
								type="email"
								value={
									this.props.pbServiceList.contactDetails
										? this.props.pbServiceList.contactDetails.email
										: ''
								}
								onChange={(text) => this.onInputChange(text, 'email')}
								onBlur={(text) => this.onInputBlurContact(text, 'email')}
								error={this.state.emailError ? true : false}
								errorMessage={this.state.emailError ? this.state.emailError.message : ''}
							/>
						</td>
						<td className="email-input">
							<KuposInput
								className="kupos-border"
								type="email"
								value={
									this.props.pbServiceList.contactDetails
										? this.props.pbServiceList.contactDetails.confirmEmail
										: ''
								}
								onChange={(text) => this.onInputChange(text, 'confirmEmail')}
								onBlur={(text) => this.onInputBlurContact(text, 'confirmEmail')}
								error={this.state.confirmEmailError ? true : false}
								errorMessage={
									this.state.confirmEmailError ? this.state.confirmEmailError.message : ''
								}
							/>
						</td>
						<td className="phone-input">
							<KuposInput
								placeholder="9 xxxx xxxx"
								className="kupos-border"
								type="number"
								value={
									this.props.pbServiceList.contactDetails
										? this.props.pbServiceList.contactDetails.mobile
										: ''
								}
								onChange={(text) => this.onInputChange(text, 'mobile')}
								onBlur={(text) => this.onInputBlurContact(text, 'mobile')}
								error={this.state.mobileError ? true : false}
								errorMessage={this.state.mobileError ? this.state.mobileError.message : ''}
							/>
						</td>
					</tr>
				</tbody>
			</table>
		);
	};

	render() {
		console.log('hello ------ ', this.props);
		return (
			<div className="pb-service-list-payment-details-page content-container flex-row passenger-and-payment-details-container">
				<div className="passenger-input-container">
					<div className="kupos-card dont-have-account-block flex-row">
						<div>
							<div className="bold">Don't have an account?</div>
							<div>Create yours and get benefits!</div>
						</div>
						<div>
							<button className="kupos-button">Create account</button>
						</div>
					</div>
					<div className="kupos-card passenger-input-details">
						<div className="flex-row passenger-details-title-row">
							<div>
								Passenger <span className="bold">details</span>
							</div>
							<div className="primary-text bold">
								<img src="/static/images/icons/icon-countdown.png" />
								09:00
							</div>
						</div>
						<div className="passenger-inputs-block">
							<span className="bold journey-type-title">Going</span>
						</div>
						{/* <table>
                  <tbody>
                    <tr className="passenger-input-heading bold">
                        <th className="nationality-input">Nationality</th>
                        <th className="rut-input">RUT / Passport / DNI</th>
                        <th className="name-input">Name</th>
                        <th className="surname-input">Surname</th>
                    </tr>
                    {
                      (this.props.pbServiceList && this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook) ? this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook.map((val,key) => {
                          return <tr key={key} className="passenger-input">
                          <td className="nationality-input"><div className="select-box flex-row kupos-border"></div></td>
                          <td className="rut-input"><KuposInput className="kupos-border" type="text" /></td>
                          <td className="name-input"><KuposInput className="kupos-border" type="text" /></td>
                          <td className="surname-input"><KuposInput className="kupos-border" type="text" /></td>
                      </tr>
                      }) : null
                    }
                  </tbody>
              </table> */}

						{this.props.pbServiceList.bookingDetailsOnward &&
							this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook ? (
							<BookingInput
								selectedSeatsToBook={
									this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
								}
								idCardTypes={this.state.idCardTypes}
								countries={this.countries}
								passengerDetails={this.props.pbServiceList.passengerDetailsOnward}
								onNameChange={(text, seat) => this.onNameChange(text, seat)}
								onSurnameChange={(text, seat) => this.onSurnameChange(text, seat)}
								onCountryChange={(val, seat) => this.onCountryChange(val, seat)}
								onIdCardChange={(label, seat) => this.onIdCardChange(label, seat)}
								onIdCardNumberChange={(text, seat) => this.onIdCardNumberChange(text, seat)}
								onInputBlur={(text, seat, inp) => this.onInputBlur(text, seat, inp)}
								nameError={this.state.nameError}
								surnameError={this.state.surnameError}
								cardNumberError={this.state.cardNumberError}
								seatsTitle="DATOS DEL PASAJERO (IDA)"
							/>
						) : null}

						{this.props.home.returnPBDate &&
							this.props.pbServiceList.bookingDetailsReturn &&
							this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook ? (
							<div>
								<div className="passenger-inputs-block">
									<span className="bold journey-type-title">Return </span>
									<span>
										<input type="checkbox" /> Apply same passenger details of going trip.
									</span>
								</div>
								<BookingInput
									selectedSeatsToBook={
										this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
									}
									idCardTypes={this.state.idCardTypesReturn}
									countries={this.countries}
									passengerDetails={this.props.pbServiceList.passengerDetailsReturn}
									onNameChange={(text, seat) => this.onNameChangeReturn(text, seat)}
									onSurnameChange={(text, seat) => this.onSurnameChangeReturn(text, seat)}
									onCountryChange={(val, seat) => this.onCountryChangeReturn(val, seat)}
									onIdCardChange={(label, seat) => this.onIdCardChangeReturn(label, seat)}
									onIdCardNumberChange={(text, seat) => this.onIdCardNumberChangeReturn(text, seat)}
									onInputBlur={this.onInputBlurReturn}
									nameError={this.state.nameReturnError}
									surnameError={this.state.surnameReturnError}
									cardNumberError={this.state.cardNumberReturnError}
									seatsTitle="DATOS DEL PASAJERO (VUELTA)"
								/>
							</div>
						) : null}
						{this.renderContactInputTable()}
					</div>
				</div>
				<PaymentRightSideBar
					walletMoneyAdded={this.walletMoneyAdded}
					virtualMoneyAmount={this.virtualMoneyAmount}
					basicFare={this.basicFare}
					calculateNetFare={this.calculateNetFare}
					calculateNetFareUSD={this.calculateNetFareUSD}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/features/pb-service-list/PaymentDetailsPage.js